import React from 'react';
import style from '../orderItemDetail.module.scss';
import cn from 'classnames';
import TagList from './TagList';
import DisclaimerBanner from './DisclaimerBanner';
import DescriptionSection from './DescriptionSection';

const LEFT_COL_STYLE = {
  width: '50%',
  flexShrink: 0,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  overflow: 'hidden',
  position: 'sticky',
  top: 0,
  height: '325px',
  alignSelf: 'flex-start'
};
const IMG_PLACEHOLDER_STYLE = { height: '100%', display: 'block', maxWidth: '100%' };
const IMG_HIDDEN_STYLE = { width: '100%', height: '100%', visibility: 'hidden', display: 'block' };

const ItemFactsPane = React.memo(({ ItemDetails, imgSrc, imgClassName }) => {
  const hasImage = Boolean(imgSrc);
  return (
    <>
      <div className={cn(style.itemDetailsContainer)} style={{ alignItems: 'stretch', height: '100%', overflow: 'hidden' }}>
        <div style={LEFT_COL_STYLE}>
          {hasImage ? (
            <img
              src={imgSrc}
              alt=""
              className="rounded"
              style={IMG_PLACEHOLDER_STYLE}
            />
          ) : (
            <div style={IMG_HIDDEN_STYLE} />
          )}
        </div>

        <div className="d-flex flex-column" style={{ flex: 1, alignSelf: 'stretch' }}>
          <DescriptionSection
            name={ItemDetails.name}
            description={ItemDetails.description}
          />
          <div style={{ marginTop: 'auto' }}>
            <TagList tags={ItemDetails.tags} />
            {ItemDetails.disclaimer && <DisclaimerBanner text={ItemDetails.disclaimer} />}
          </div>
        </div>
      </div>
    </>
  );
});

export default ItemFactsPane;
